import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import "../productos.css";

const Producto = ({ image, images, name, price, oldPrice, slug, variants = [] }) => {

  const colorVariants = useMemo(() => {
    return variants.filter(v => v?.color && (v?.images?.[0] || v?.image));
  }, [variants]);

  const [activeImage, setActiveImage] = useState(null);
  const getVariantImage = (variant) => variant?.images?.[0] || variant?.image;
  const baseImage = images?.[0] || image;

  useEffect(() => {
    setActiveImage(getVariantImage(colorVariants[0]) || baseImage);
  }, [colorVariants, baseImage]);

  const displayPrice =
    typeof price === "number"
      ? price
      : colorVariants.length
      ? colorVariants[0].price
      : price;

  const hasDiscount = oldPrice > displayPrice;
  const discountPercent = hasDiscount
    ? Math.round((1 - displayPrice / oldPrice) * 100)
    : 0;

  return (
    <div className="productList">
      <div className="prodCont">
        <Link to={slug ? `/producto/${slug}` : "#"} className="productCard">

          <div
            className="productImageWrapper"
            onMouseLeave={() =>
              setActiveImage(getVariantImage(colorVariants[0]) || baseImage)
            } 
          >
          <img
            src={activeImage}
            alt={name}
            className="productImage"
            loading="lazy"
            decoding="async"
          />

            {hasDiscount && (
              <span className="discountBadge">-{discountPercent}%</span>
            )}

            {colorVariants.length > 1 && (
              <div className="variant-thumbs">
                {colorVariants.slice(0, 4).map((v, i) => {
                  const variantImage = getVariantImage(v);

                  return (
                    <img
                      key={i}
                      src={variantImage}
                      alt={v.color}
                      className={`variant-thumb ${
                        activeImage === variantImage ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveImage(variantImage)}
                    />
                  );
                })}
                {colorVariants.length > 4 && (
                  <div className="variant-more">
                    +{colorVariants.length - 4}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="productCard__content">
            <h3 className="productName">{name}</h3>
            {hasDiscount ? (
              <div className="productPrice productPrice--sale">
                <del className="productPrice__old">US$ {oldPrice}</del>
                <span className="productPrice__new">US$ {displayPrice}</span>
              </div>
            ) : (
              <div className="productPrice">
                US$ {displayPrice}
              </div>
            )}
          </div>

        </Link>
      </div>
    </div>
  );
};

export default Producto;
